const API = process.env.REACT_APP_API_URL;

async function fetchJson(url) {
  const response = await fetch(url, { credentials: "include" });
  const payload = await response.json();

  if (!response.ok) {
    throw new Error(payload.error || payload.detail || "Quiz-Analyse konnte nicht geladen werden.");
  }

  return payload;
}

export async function fetchQuizAnalyticsBundle({ patients: initialPatients } = {}) {
  const patientIds = Array.isArray(initialPatients)
    ? initialPatients.map((patient) => patient?.id).filter(Boolean)
    : [];
  const query = patientIds.length ? `?patient_ids=${patientIds.join(",")}` : "";
  return fetchJson(`${API}/quiz_analytics${query}`);
}
